import React, { useState, useEffect, useCallback, forwardRef } from "react";
import { TextField, InputLabel, Select, MenuItem, FormControl, Input, FormHelperText } from "@mui/material";
import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import ModalStyles from "components/Content/Modal/ModalStyles.module.css";
import _ from "lodash";
import { Utils } from "common/Utils";

const viewDataOnly = false
const ChangeEmployeeBenefits = forwardRef(({ fetchedData, employee ,errors}, ref) => {
  const [formData, setFormData] = useState(fetchedData);
  const [costShares, setCostShares] = useState([]);
  useEffect(() => {
    fetchCostShare(employee.benefitPackageID, fetchedData.benefitID)
  }, [employee]);

  const fetchCostShare = (benefitPackageId, benefitId) => {
    console.log(benefitPackageId, "benefitPackageId");
    console.log(benefitId, "benefitId");
    apiGet(apiUrls.getCostShares(benefitPackageId, benefitId)).then(
      (lovResponse) => {
        let lovResponseData = lovResponse.data;
        console.log(lovResponseData, "fetchCostShare");
        setCostShares(lovResponseData)
      }
    )
  }

  const handleChange = _.debounce((name, val, costShares) => {
    console.log(' in handle change Change Employee Benefits')
    let updatedValue = { [name]: val };
    if (name == 'coverageLevelID') {
      console.log(costShares, ' in handle change')
      let cs = costShares.find(c => c.coverageLevelID == val);
      updatedValue = { [name]: val, 'coverage': cs.coverageLevelName };
    }
    setFormData(formData => ({
      ...formData,
      ...updatedValue
    }));
    if (ref?.current) {
      ref.current.formData = {
        ...formData,
        ...updatedValue
      };
    }
  }, 500);


  return (
    <>

      <TextField
        variant="standard"
        className={ModalStyles.cField}
        label="Carrier"
        defaultValue={formData.carrier}
        InputProps={{
          readOnly: true,
        }}
      />

      <TextField
        variant="standard"
        className={ModalStyles.cField}
        label="Benefit Name"
        defaultValue={formData.benefit}
        InputProps={{
          readOnly: true,
        }}

      />

      <FormControl sx={{ m: 1, minWidth: 150 }}
        className={ModalStyles.cField}>
        <InputLabel >Coverage Level</InputLabel>
        <Select
          id="coverageLevelID"
          name="coverageLevelID"
          label="Coverage Level"
          value={formData.coverageLevelID || ''}
          required
          shrink
          size="small"
          variant="standard"
          onChange={e => handleChange('coverageLevelID', e.target.value, costShares)}
          error={errors.coverageLevelID ? true : false}
          helperText={errors.coverageLevelID}
        >

          {costShares.map((val, i) => <MenuItem value={val.coverageLevelID} key={i}>{val.coverageLevelName}</MenuItem>)}
        </Select>
      </FormControl>

      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="Coverage Amount"
        defaultValue={
          formData.coverageAmount === null && viewDataOnly
            ? 0
            : formData.coverageAmount
        }
        onChange={e => handleChange('coverageAmount', e.target.value)}
        error={errors.coverageAmount ? true : false}
        helperText={errors.coverageAmount}
      />

      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="EE Monthly Cost"
        defaultValue={
          formData.eeCost == null && viewDataOnly
            ? 0
            : formData.eeCost
        }
        onChange={e => handleChange('eeCost', e.target.value)}
        error={errors.eeCost ? true : false}
        helperText={errors.eeCost}
      />

      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="ER Monthly Cost"
        defaultValue={
          formData.erCost == null && viewDataOnly
            ? 0
            : formData.erCost
        }
        onChange={e => handleChange('erCost', e.target.value)}
        error={errors.erCost ? true : false}
        helperText={errors.erCost}
      />

<FormControl 
        className={ModalStyles.cField} 
        error={errors.startDate ? true : false}>
        <InputLabel shrink>Effective Date</InputLabel>
        <Input id="my-input" aria-describedby="my-helper-text" type="date"
        defaultValue={
          (formData.startDate == null) && viewDataOnly
            ? ""
            : Utils.convertToDatePicker(formData.startDate)
        }
        onChange={e => handleChange('startDate', e.target.value)}
        />
        <FormHelperText id="component-error-text">{errors.startDate}</FormHelperText>
      </FormControl>

      <FormControl 
        className={ModalStyles.cField} 
        error={errors.termDate ? true : false}>
        <InputLabel shrink>Termination Date { (formData.termDate == null || formData.termDate == '') ?"y":"n" }</InputLabel>
        <Input id="my-input" aria-describedby="my-helper-text" type="date"
        defaultValue={
          (formData.termDate == null || formData.termDate == '') 
            ? ""
            : Utils.convertToDatePicker(formData.termDate)
        }
        onChange={e => handleChange('termDate', e.target.value)}
        />
        <FormHelperText id="component-error-text">{errors.termDate}</FormHelperText>
      </FormControl>

    </>
  )
});

export default ChangeEmployeeBenefits;